import Vue from 'vue'
import Vuex from 'vuex'
import indexes from './modules/indexes'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		indexes, user
	}
})
